export default "__VITE_ASSET__802cf541__"